import { Directive, HostListener } from '@angular/core';

import { SnRouteStackService } from '../services';

@Directive({
  selector: '[snRouteBack]',
})
export class SnRouteBackDirective {
  constructor(private readonly _routeStack: SnRouteStackService) {}

  @HostListener('click')
  public onClick(): void {
    this._routeStack.back();
  }
}
